import { useModal } from '@/common/components/modal-provider/hooks/useModal.ts';
import {
  ConfirmDialogContent,
  ConfirmDialogOptions,
} from '@/common/components/confirm-dialog/ConfirmDialog.tsx';

export function useConfirmDialog() {
  const showModal = useModal();
  return (options: ConfirmDialogOptions): Promise<boolean | undefined> =>
    showModal<boolean>({
      maxWidth: 'sm',
      content: ({ resolve }) => (
        <ConfirmDialogContent
          {...options}
          onConfirm={() => resolve(true)}
          onCancel={() => resolve(false)}
        />
      ),
    });
}
